import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import Login from './Login';
import Dashboard from './Dashboard';
import { showToast, setSessionExpiredHandler, resetSessionExpired } from './lib';
import { ErrorBoundary, FullScreenSpinner, ToastContainer, LoadingBar } from './ui';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  // Re-login automático: si una llamada detecta la sesión caducada (401/403),
  // se vuelve a la pantalla de login sin recargar la app.
  useEffect(() => {
    setSessionExpiredHandler(() => {
      setIsAuthenticated(false);
      showToast(
        'warning',
        'Sesión expirada',
        'Tu sesión caducó. Por favor inicia sesión de nuevo.'
      );
    });
    return () => setSessionExpiredHandler(null);
  }, []);

  useEffect(() => {
    let mounted = true;
    const checkAuthentication = async () => {
      try {
        const response = await fetch('/auth-check', {
          method: 'GET',
          credentials: 'include',
        });

        if (!mounted) return;

        if (response.ok) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error checking authentication', error);
        if (mounted) setIsAuthenticated(false);
      }
    };

    checkAuthentication();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ErrorBoundary>
      <LoadingBar />
      <ToastContainer />
      {isAuthenticated === null ? (
        <FullScreenSpinner label="Verificando sesión..." />
      ) : (
        <Router>
          <Routes>
            <Route
              path="/login"
              element={
                isAuthenticated ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Login
                    onAuthenticated={() => {
                      resetSessionExpired();
                      setIsAuthenticated(true);
                    }}
                  />
                )
              }
            />
            <Route
              path="/dashboard"
              element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
            />
            <Route path="*" element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} />} />
          </Routes>
        </Router>
      )}
    </ErrorBoundary>
  );
}

export default App;
